import BaseApi from "./base";

class NotasClientesApi extends BaseApi {
  constructor() {
    super("notas_clientes");
  }
}

export default new NotasClientesApi();
